// 商品ページの「販売価格は本数を選ぶと表示されます。」の注記（Issue #70 の 3 本目）。
// おちゃのこがバリエーション商品（pConf.variationFlag）で価格を出さないとき、.selling_price の後ろに 1 行足す。
// wuSiteResource2 の PaperStraw/ProductDetails.ts の引き取り先。
//
//   if (pConf.variationFlag) {
//     $(".selling_price").after('  <p><span class="sell-price">販売価格</span>は<span class="nimber-of">本数</span>を選ぶと表示されます。</p>');
//   }
//
// ★ class 名 nimber-of（綴り違い）は店の CSS が当てている可能性があるのでそのまま。
// ★ コミック侍(11) にも同じコード（文言「枚数」）があったが、70 商品すべて variationFlag=false で一度も出ていない
//   （2026-09-23 実測・Issue #70 コメント）ので移さずに捨てた。表に 11 は無い。
// ★ 過渡期に 2 回出ない: 旧実装（jQuery ready）より後に走らせ、直後に注記（.nimber-of）が既にあれば足さない。

import { afterOldScripts } from '../shared/after-old-scripts'

/** 店 → 「◯◯を選ぶと」の単位。表にある店だけ発動 */
export const PRICE_VARIATION_UNIT: Record<number, string> = {
  9: '本数', // 紙ストロー。4 商品（/product/28 /49 /103 /120）で variationFlag=true
}

export const NOTE_CLASS = 'nimber-of'

/** 旧実装の HTML と同じ構造の <p> を組む（sell-price / nimber-of の span、文言） */
export function buildNote(doc: Document, unit: string): HTMLParagraphElement {
  const p = doc.createElement('p')
  const price = doc.createElement('span')
  price.className = 'sell-price'
  price.textContent = '販売価格'
  const num = doc.createElement('span')
  num.className = NOTE_CLASS
  num.textContent = unit
  p.append(price, 'は', num, 'を選ぶと表示されます。')
  return p
}

/** .selling_price ごとに注記を足す。次の要素が既に注記なら足さない。戻り値は足した数 */
export function insertPriceVariationNote(doc: Document, unit: string): number {
  let n = 0
  doc.querySelectorAll<HTMLElement>('.selling_price').forEach((p) => {
    if (p.nextElementSibling?.querySelector(`.${NOTE_CLASS}`)) return
    p.after(buildNote(doc, unit))
    n++
  })
  return n
}

export default function priceVariationNote(): void {
  const siteId = window.wu?.siteInfoId
  const unit = siteId ? PRICE_VARIATION_UNIT[siteId] : undefined
  if (!unit) return
  const flag = (window as unknown as { pConf?: { variationFlag?: unknown } }).pConf?.variationFlag
  if (!flag) return
  afterOldScripts(() => insertPriceVariationNote(document, unit))
}
